import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import AppContainer from './AppContainer';
import Error from './Error';
import Done from './Done';
import Forward from './Forward';
import HomePage from './homepage/Home';
import PaymentDirect from './PaymentDirect';

import { setLanguage } from './utils';
import { LanguageProvider } from './LanguageContext';
import MaboxGuideProfiles from './MapboxGuideProfiles';

const AboutBoggler = lazy(() => import('./AboutBoggler'));
const TermsOfUse = lazy(() => import('./TermsOfUse'));
const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));
const PaymentReturn = lazy(() => import('./PaymentReturn'));
const Contribute = lazy(() => import('./Contribute'));
const ContributionThanks = lazy(() => import('./ContributionThanks'));
const InvestorStatus = lazy(() => import('./InvestorStatus'));
const PaymentSuccess = lazy(() => import('./PaymentSuccess'));
const PaymentCancel = lazy(() => import('./PaymentCancel'));
const ChooseAccount = lazy(() => import('./ChooseAccount'));
const SignupAsGuide = lazy(() => import('./SignupAsGuide'));
const SuggestArchetype = lazy(() => import('./SuggestArchetype'));
const Payment = lazy(() => import('./Payment'));
const UploadForGhosted = lazy(() => import('./UploadForGhosted'));
const Blog = lazy(() => import('./Blog'));
const Account = lazy(() => import('./Account'));
const TalkToGuide = lazy(() => import('./TalkToGuide'));
const GuideSignup = lazy(() => import('./GuideSignup'));
const GuideApprovalPending = lazy(() => import('./GuideApprovalPending'));
const GuideProfile = lazy(() => import('./GuideProfile'));
const MakeCall = lazy(() => import('./MakeCall'));
const ReviewCall = lazy(() => import('./ReviewCall'));
const ConfirmRequest = lazy(() => import('./ConfirmRequest'));
const Scheduler = lazy(() => import('./Scheduler'));
const PaidForProposedCall = lazy(() => import('./PaidForProposedCall'));
const UberModeRequest = lazy(() => import('./UberModeRequest'));
const ViewGuideCall = lazy(() => import('./ViewGuideCall'));
const SubscribeToGuide = lazy(() => import('./SubscribeToGuide'));
const ConfirmGuideEmail = lazy(() => import('./ConfirmGuideEmail'));
const GuideEmailConfirmationSuccess = lazy(() => import('./GuideEmailConfirmationSuccess'));
const GuidePaymentPromptRedirect = lazy(() => import('./GuidePaymentPromptRedirect'));
const DmDilly = lazy(() => import('./dmdilly/App.jsx'));

const root = ReactDOM.createRoot(document.getElementById('root'));

// Helper to get query param
function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

let preferredLanguage = getQueryParam("lang") || 
    localStorage.getItem("buckish-language") || 
    (navigator.language.startsWith("si") ? "sinhala" : "english")


if (preferredLanguage === "sinhala") {
  document.documentElement.lang = "si";
}

//Temporarily set the language for the session to english 

setLanguage("english");

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={
          <div style={{ textAlign: 'center', marginTop: '50px', height: "100vh", width: "100vw" }}>
            <div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
              <img style={{width: "75%", height: "auto"}} src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp" alt="Boggler Logo" />
            </div>
          </div>}>
          <Routes>
            <Route element={<AppContainer />}>
              <Route index element={<HomePage />} />
              <Route 
                path="/contribution-return" 
                element={<ContributionThanks />} />
              <Route 
                path="/investor-status" 
                element={<InvestorStatus />} />
              <Route 
                path="/about" 
                element={<AboutBoggler />} />
              <Route 
                path="/blog/:title/:p" 
                element={<Blog />} />
              <Route 
                path="/done" 
                element={<Done />} />
              <Route 
                path="/error" 
                element={<Error />} />
              <Route 
                path="/t/:twilio_conversation_id/upload/:e_ph" 
                element={<UploadForGhosted />} />
              <Route 
                path="/start/:twilio_conversation_id" 
                element={<PaymentDirect />} />
              <Route 
                path="/t/:twilio_conversation_id/pay/:e_ph/:type/:guideType?/:guideID?" 
                element={<Payment />} />
              <Route 
                path="/payment-return" 
                element={<PaymentReturn />} />
              <Route 
                path="/payment-success" 
                element={<PaymentSuccess />} />
              <Route 
                path="/payment-cancel" 
                element={<PaymentCancel />} />
              <Route
                path="/pay-guide/:promptId"
                element={<GuidePaymentPromptRedirect />}
              />
              <Route 
                path="/terms-of-use" 
                element={<TermsOfUse />} />
              <Route 
                path="/privacy-policy" 
                element={<PrivacyPolicy />} />
              <Route
                path="/the-love-map"
                element={<Forward pathname="/the-love-map" />}
              />
              <Route
                path="/the-love-map-sinhala"
                element={<Forward pathname="/the-love-map-sinhala" />}
              />
              <Route
                path="/david-hawkins-map"
                element={<Forward pathname="/david-hawkins-map" />}
              />
              <Route
                path="/david-hawkins-map-sinhala"
                element={<Forward pathname="/david-hawkins-map-sinhala" />}
              />
              <Route
                path="/account"
                element={<Account />}
              />
              <Route
                path="/signup-as-guide"
                element={<GuideSignup />}
              />
               <Route
                path="/guide/signup/approval-pending/:encrypted_phone_number"
                element={<GuideApprovalPending />}
              />
              <Route
                path="/guide/signup/form/:encrypted_phone_number/:confirmation_code/:application_id?"
                element={<SignupAsGuide />}
              />
              <Route
                path="/guide/call/makecall/:scheduledCallID"
                element={<MakeCall />}
              />

              <Route
                path="/guide/pick-guide/:e_ph"
                element={<MaboxGuideProfiles />}
              /> 

              <Route
                path="/pick-guide/:e_ph"
                element={<MaboxGuideProfiles />}
              /> 

              <Route
                path="/pick-guide"
                element={<MaboxGuideProfiles />}
              /> 

              <Route 
                path="/guide/confirm-email/:application_id/:confirmation_code" 
                element={<ConfirmGuideEmail />} />

              <Route 
                path="/guide/email-confirmation-success" 
                element={<GuideEmailConfirmationSuccess />} />

              <Route 
                path="/guide/profile/:guideID/:encrypted_phone_number/:type?" 
                element={<GuideProfile />} />

              <Route
                path="/guide/talk/:guideType/:encrypted_phone_number/:type"
                element={<TalkToGuide />}
              />

              <Route
                path="/guide/suggest-archetype/:encrypted_phone_number/:confirmation_code"
                element={<SuggestArchetype />}
              />

               <Route
                path="/paid-for-proposed-call/:noteID"
                element={<PaidForProposedCall />}
              />

              <Route
                path="/uber-mode/call-request/:noteID"
                element={<UberModeRequest />}
              />

              <Route
                path="/call/view-guide/:scheduledCallID"
                element={<ViewGuideCall />}
              />

              <Route
                path="/call/review/:scheduledCallID"
                element={<ReviewCall />}
              />

              <Route
                path="/call/confirm-request/:noteID"
                element={<ConfirmRequest />}
              />

              <Route
                path="/call/makecall/:scheduledCallID"
                element={<MakeCall />}
              />

               <Route
                path="/call/scheduler/:guideID/:scheduledCallID/:encrypted_phone_number/:confirmation_code"
                element={<Scheduler />}
              />

              <Route
                path="/call/scheduler/:guideID/:scheduledCallID/:encrypted_phone_number/:confirmation_code/reschedule-with-guide"
                element={<Scheduler sameGuide={true} isReschedule={true} />}
              />

              <Route
                path="/review/subscribe-to-guide/:guideID/:scheduledCallID/:encrypted_phone_number/:type"
                element={<SubscribeToGuide />}
              />

              <Route 
                path="/:guidePhoneNumberOrUserName"
                element={<Payment />}
              />

              <Route 
                path="/profile/:guideID/:customerID"
                element={<Payment />}
              />

              <Route 
                path="/profile/:guideID"
                element={<Payment />}
              />

              <Route
                path="/choose-account"
                element={<ChooseAccount />}
              />

              <Route
                path="*"
                element={<Error />}
              />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);
